export default __webpack_public_path__ + "static/media/mulher.ccf0ef11.svg";